import { gql } from '@apollo/client';

export const SETTINGS_BRANCHES_QUERY = gql`
  query SettingsBranches {
    branches {
      id
      name
    }
  }
`;

export const WORKSTATION_FIELDS = gql`
  fragment SettingsWorkstationFields on Workstation {
    id
    branch_id
    kind
    display_name
    status
    created_at
    updated_at
  }
`;

export const WORKSTATIONS_QUERY = gql`
  ${WORKSTATION_FIELDS}
  query SettingsWorkstations(
    $offset: Int
    $limit: Int
    $search: String
    $status_filter: CatalogStatusFilter
    $branch_id: ID
  ) {
    workstations(
      offset: $offset
      limit: $limit
      search: $search
      status_filter: $status_filter
      branch_id: $branch_id
    ) {
      items {
        ...SettingsWorkstationFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const ACTIVE_WORKSTATIONS_QUERY = gql`
  ${WORKSTATION_FIELDS}
  query SettingsActiveWorkstations($branch_id: ID) {
    workstations(branch_id: $branch_id, limit: 200, status_filter: ACTIVE) {
      items {
        ...SettingsWorkstationFields
      }
    }
  }
`;

export const CREATE_WORKSTATION_MUTATION = gql`
  ${WORKSTATION_FIELDS}
  mutation SettingsCreateWorkstation($input: CreateWorkstationInput!) {
    createWorkstation(input: $input) {
      ...SettingsWorkstationFields
    }
  }
`;

export const UPDATE_WORKSTATION_MUTATION = gql`
  ${WORKSTATION_FIELDS}
  mutation SettingsUpdateWorkstation($id: ID!, $input: UpdateWorkstationInput!) {
    updateWorkstation(id: $id, input: $input) {
      ...SettingsWorkstationFields
    }
  }
`;

export const SET_WORKSTATION_STATUS_MUTATION = gql`
  ${WORKSTATION_FIELDS}
  mutation SettingsSetWorkstationStatus($id: ID!, $status: String!) {
    setWorkstationStatus(id: $id, status: $status) {
      ...SettingsWorkstationFields
    }
  }
`;

export const CONSULTING_ROOM_FIELDS = gql`
  fragment SettingsConsultingRoomFields on ConsultingRoom {
    id
    branch_id
    name
    display_order
    zone_type
    workstation_id
    status
    created_at
    updated_at
  }
`;

export const CONSULTING_ROOMS_QUERY = gql`
  ${CONSULTING_ROOM_FIELDS}
  query SettingsConsultingRooms(
    $offset: Int
    $limit: Int
    $search: String
    $status_filter: CatalogStatusFilter
    $branch_id: ID
  ) {
    consultingRooms(
      offset: $offset
      limit: $limit
      search: $search
      status_filter: $status_filter
      branch_id: $branch_id
    ) {
      items {
        ...SettingsConsultingRoomFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const CREATE_CONSULTING_ROOM_MUTATION = gql`
  ${CONSULTING_ROOM_FIELDS}
  mutation SettingsCreateConsultingRoom($input: CreateConsultingRoomInput!) {
    createConsultingRoom(input: $input) {
      ...SettingsConsultingRoomFields
    }
  }
`;

export const UPDATE_CONSULTING_ROOM_MUTATION = gql`
  ${CONSULTING_ROOM_FIELDS}
  mutation SettingsUpdateConsultingRoom($id: ID!, $input: UpdateConsultingRoomInput!) {
    updateConsultingRoom(id: $id, input: $input) {
      ...SettingsConsultingRoomFields
    }
  }
`;

export const SET_CONSULTING_ROOM_STATUS_MUTATION = gql`
  ${CONSULTING_ROOM_FIELDS}
  mutation SettingsSetConsultingRoomStatus($id: ID!, $status: String!) {
    setConsultingRoomStatus(id: $id, status: $status) {
      ...SettingsConsultingRoomFields
    }
  }
`;

export const CASH_REGISTER_FIELDS = gql`
  fragment SettingsCashRegisterFields on CashRegister {
    id
    branch_id
    name
    workstation_id
    status
    created_at
    updated_at
  }
`;

export const CASH_REGISTERS_QUERY = gql`
  ${CASH_REGISTER_FIELDS}
  query SettingsCashRegisters(
    $offset: Int
    $limit: Int
    $search: String
    $status_filter: CatalogStatusFilter
    $branch_id: ID
  ) {
    cashRegisters(
      offset: $offset
      limit: $limit
      search: $search
      status_filter: $status_filter
      branch_id: $branch_id
    ) {
      items {
        ...SettingsCashRegisterFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const CREATE_CASH_REGISTER_MUTATION = gql`
  ${CASH_REGISTER_FIELDS}
  mutation SettingsCreateCashRegister($input: CreateCashRegisterInput!) {
    createCashRegister(input: $input) {
      ...SettingsCashRegisterFields
    }
  }
`;

export const UPDATE_CASH_REGISTER_MUTATION = gql`
  ${CASH_REGISTER_FIELDS}
  mutation SettingsUpdateCashRegister($id: ID!, $input: UpdateCashRegisterInput!) {
    updateCashRegister(id: $id, input: $input) {
      ...SettingsCashRegisterFields
    }
  }
`;

export const SET_CASH_REGISTER_STATUS_MUTATION = gql`
  ${CASH_REGISTER_FIELDS}
  mutation SettingsSetCashRegisterStatus($id: ID!, $status: String!) {
    setCashRegisterStatus(id: $id, status: $status) {
      ...SettingsCashRegisterFields
    }
  }
`;

export const PET_SPECIES_CATALOG_QUERY = gql`
  query SettingsPetSpeciesCatalog {
    petSpeciesCatalog {
      value
      is_system
    }
  }
`;

export const SET_PET_SPECIES_CATALOG_MUTATION = gql`
  mutation SettingsSetPetSpeciesCatalog($input: SetPetSpeciesCatalogInput!) {
    setPetSpeciesCatalog(input: $input) {
      value
      is_system
    }
  }
`;

export const WAITING_ROOM_DISPLAY_SETTINGS_QUERY = gql`
  query SettingsWaitingRoomDisplaySettings {
    waitingRoomDisplaySettings {
      youtube_playlist_id
      is_configured
      refresh_token
    }
  }
`;

export const SET_WAITING_ROOM_DISPLAY_SETTINGS_MUTATION = gql`
  mutation SettingsSetWaitingRoomDisplaySettings($input: SetWaitingRoomDisplaySettingsInput!) {
    setWaitingRoomDisplaySettings(input: $input) {
      youtube_playlist_id
      is_configured
      refresh_token
    }
  }
`;
